/**
 * Calculate BMI
 * @param {number} height - Height in number
 * @param {number} weight - Weight in number
 * @returns {number} - BMI with 2 decimal digits
 */
export const bmiCalculate = (height = 0, weight = 0): number => {
  try {
    if (height && weight) {
      const bmi = weight / Math.pow(height / 100, 2)
      return bmi
    } else {
      return 0
    }
  } catch (error) {}
  return 0
}
